<style lang="less">
@import "../less/common.less";
@import "./login.less";
</style>
<template>
  <div class="main login">
    <div class="sunlight"></div>
    <div class="sunlight"></div>
    <div class="sunlight"></div>
    <div class="sunlight"></div>
    <el-row :gutter="20">
      <el-col class="login_img" :span="12">&nbsp;</el-col>
      <el-col :span="12">
          <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="">
           <p class="title-login">欢迎来到阿中分析系统</p>
           <div class="tips">请先登录账号</div>
        </el-form-item>
        <el-form-item label="" prop="name">
          <el-input v-model.trim="ruleForm.name" placeholder="请输入账号名称" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="" prop="pass">
          <el-input type="password" v-model.trim="ruleForm.pass" placeholder="请输入账号密码" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="but-login" type="primary" :loading="true" v-if="loadingBtn">登录中</el-button>
          <el-button class="but-login" type="primary" @click="submitForm('ruleForm')" v-else>登录</el-button>
        </el-form-item>
      </el-form>
          </el-col>
          <img class="logo_img" src="../image/logo.png" alt="..." />
          </el-row>
    </div>
  </div>
</template>

<script>
import {
    localToken
} from '@/libs/util';
import loginApi from "@/api/api-login";
import {
    Message
} from 'element-ui'
  export default {
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入账号密码'));
        }
        else {
          // if (this.ruleForm.checkPass !== '') {
          //   this.$refs.ruleForm.validateField('checkPass');
          // }
          callback();
        }
      };
      var validateName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入账号名称'));
        } else {
          callback();
        }
      };
      return {
        loadingBtn:false,
        ruleForm: {
          pass: '',
          name: ''
        },
        rules: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          name: [
            { validator: validateName, trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
    // 登陆
    handleLogin() {
      let that = this;
      let name = that.ruleForm.name;
      let pass = that.ruleForm.pass;
      return new Promise((resolve, reject) => {
        let data = {
           loginName: name,
           password: pass
        };
        loginApi
          .login(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
      submitForm(formName) {
        let that = this;
        that.loadingBtn = true
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.handleLogin().then(
              res => {

                if (res != null) {
                  that.$router.push({
                    path: "/main"
                  });
                  that.loadingBtn = false
                } else {
                  that.loadingBtn = false
                }
              },
              err => {
                Message({
                    message: '请正确填写账号信息、商户号',
                    type: 'error'
                });
                that.loadingBtn = false
              }
            );
          } else {
            that.loadingBtn = false
            console.log('error submit!!');
            return false;
          }
        });

      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/view/login/login.20210915.vue